import {
  Box,
  Button,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import { MainRoutePath } from 'library/Routes';
import translation from 'locales/translation';
import { useHistory } from 'react-router-dom';

export interface IUnauthorizedScreen {
  label?: string;
  callback?: Function;
  callbackLabel?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '100%',
      height: '100vh',
      padding: theme.spacing(),
      boxSizing: 'border-box',
    },
    label: {
      textAlign: 'center',
    },
    logoutButton: {
      textAlign: 'center',
      marginTop: '15px',
      alignSelf: 'center',
    },
  })
);

export default function UnauthorizedScreen({
  label,
  callback,
  callbackLabel,
}: IUnauthorizedScreen) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box className={classes.loadingContainer}>
      <Typography className={classes.label}>
        {label || translation.UnauthorizedScreen.label}
      </Typography>
      <Button
        className={classes.logoutButton}
        variant='contained'
        color='primary'
        onClick={() => {
          if (typeof callback === 'function') {
            callback();
          } else {
            history.push(MainRoutePath);
          }
        }}
      >
        {callbackLabel || translation.UnauthorizedScreen.callbackButton}
      </Button>
    </Box>
  );
}
